import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=20512ab0&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=20512ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20512ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20512ab0')) {
      api.createRecord('20512ab0', component.options)
    } else {
      api.reload('20512ab0', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=20512ab0&scoped=true&", function () {
      api.rerender('20512ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/MeetingNote/Button.vue"
export default component.exports